import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=d5a112b6&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5a112b6')) {
      api.createRecord('d5a112b6', component.options)
    } else {
      api.reload('d5a112b6', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=d5a112b6&", function () {
      api.rerender('d5a112b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tt0K076N0Toz/JS/imageCarousel.vue"
export default component.exports